import {all, fork} from 'redux-saga/effects'

import auth from './auth'
import interfaceComponents from './interface'
import jobs from './jobs'
import task from './task'

export default function* rootSaga(): Generator {
  return yield all([
    auth,
    jobs,
    task,
    interfaceComponents,
  ].map(fork))
}
